import React from 'react';

import type { BlockTeam } from 'types/block-team';
import type { TeamMember as TeamMemberType } from 'types/team';

import { Heading, Paragraph, Wrap } from '@leafwell/components';

import Figure from './figure';
import HeadingBody from './heading-body';
import TeamPortraits from './team-portraits';

export const TeamMember: React.FC<TeamMemberType> = ({
  featuredImage,
  content,
  jobs,
  title,
}) => {
  const jobTitle = React.useMemo(() => {
    if (jobs && jobs.length > 0) {
      return jobs.map(({ name }) => name).join(', ');
    }

    return null;
  }, [jobs]);

  return (
    <article className="grid md:grid-cols-2-auto gap-x-6 xl:gap-x-10 gap-y-3 lg:gap-y-6 items-start content-start">
      <Figure {...featuredImage} className="w-32 md:row-span-3" />
      <Heading level="5" dangerouslySetInnerHTML={{ __html: title }} />
      {jobTitle && (
        <Paragraph size="small" variant="medium" className="-mt-3 lg:-mt-6">
          {jobTitle}
        </Paragraph>
      )}
      <Paragraph
        size="small"
        dangerouslySetInnerHTML={{ __html: content }}
        tagName="div"
      />
    </article>
  );
};

const Team: React.FC<BlockTeam> = ({ layout, title, items }) => {
  return layout === 'default' ? (
    <Wrap className="sm:grid-cols-2 gap-10 xl:gap-16">
      {title?.length > 0 && (
        <HeadingBody
          {...{
            className: 'col-span-full',
            level: '2',
            title,
            tagName: 'h4',
          }}
        />
      )}
      {items.map((person, key) => (
        <TeamMember key={key} {...person} />
      ))}
    </Wrap>
  ) : (
    <TeamPortraits {...{ layout, title, items }} acfFcLayout="team" />
  );
};

export default Team;
